import { NavigateFunction } from "react-router-dom";

import { OrganisationTypeConstants } from "../../constants";
import { IStateOrigin } from "../../navigators/navigateStateObjects";
import { getTaskParentObjectRoute } from "../routes";

/**
 * The click handler that opens a task's parent object, or `undefined` when that object has no
 * route for this role.
 *
 * Returning `undefined` is the meaningful half: the milestone card renders the object name as a
 * link only when it is given a handler, and as plain text otherwise — so a parent the current role
 * cannot open never presents itself as clickable. Shared by every milestone-KPI call site so the
 * four of them cannot disagree about which parents are reachable.
 *
 * `backNavigation` is carried as router state rather than as an `origin` query param, matching
 * `useTasksDashboardObjectLink`. All three destinations read `state.origin`, whereas the query param
 * is only handled by the project pages: a Landholding given an unrecognised `origin` falls through
 * to a hardcoded Developer project route built from a uuid it does not have, which sends a
 * Development Manager somewhere they did not come from.
 */
export const getTaskParentObjectNavigation = (
  parentObjectType: string | null | undefined,
  parentObjectUuid: string | null | undefined,
  userType: OrganisationTypeConstants,
  navigate: NavigateFunction,
  backNavigation?: IStateOrigin
): (() => void) | undefined => {
  const route = getTaskParentObjectRoute(parentObjectType, parentObjectUuid, userType);
  if (!route) {
    return undefined;
  }

  return () => navigate(route, backNavigation ? { state: { origin: backNavigation } } : undefined);
};
